import { Box, pn, Skeleton, Stack } from "@compass/core";
import { Export, Legend, Series, Tooltip } from "devextreme-react/pie-chart";
import PieChart from "devextreme-react/pie-chart";
import { EligibilityDistributionDto } from "generated/openApi";
import { useEligibilityData } from "../contexts/EligibilityDataContext";
import { DashboardCard } from "../components/DashboardCard";
import { useRef } from "react";
import { EligibilityFilterControls } from "./EligibilityFilterControls";

const EligibilityChartContent = (props: {
    chartRef: React.RefObject<PieChart>;
}) => {
    const { data, loading, error } = useEligibilityData();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                flexWrap="wrap"
                useFlexGap
                gap={2}
                sx={{ mb: 2 }}
            >
                <EligibilityFilterControls />
            </Stack>

            <Box sx={{ flexGrow: 1, minHeight: 0, display: "flex", justifyContent: "center" }}>
                {loading ? (
                    <Skeleton variant="rounded" width="100%" height={400} />
                ) : error ? (
                    <Box sx={{ p: 2, color: "error.main" }}>{error}</Box>
                ) : (
                    <Box sx={{ width: "100%", maxWidth: 600, aspectRatio: "4 / 3" }}>
                        <PieChart
                            ref={props.chartRef}
                            id="eligibility-chart"
                            dataSource={data}
                            palette="Material"
                            height="100%"
                        >
                            <Series
                                argumentField={pn<EligibilityDistributionDto>("eligibilityName")}
                                valueField={pn<EligibilityDistributionDto>("studentCount")}
                            />
                            <Legend
                                visible={true}
                                verticalAlignment="bottom"
                                horizontalAlignment="center"
                                columnCount={2}
                            />
                            <Tooltip
                                enabled={true}
                                customizeTooltip={(arg) => ({
                                    text: `${arg.argumentText}\nStudents: ${arg.valueText} (${arg.percentText})`,
                                })}
                            />
                            <Export enabled={false} />
                        </PieChart>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export const EligibilityChartCard = () => {
    const chartRef = useRef<PieChart>(null);

    const handleExport = () => {
        if (chartRef.current) {
            chartRef.current.instance.exportTo("EligibilityCriteria", "png");
        }
    };

    return (
        <DashboardCard title="Eligibility Criteria" onExport={handleExport}>
            <EligibilityChartContent chartRef={chartRef} />
        </DashboardCard>
    );
};